import Address from '@shared/types/virk/Address'
import axios from '@/axios'
import { createAddressAutocomplete } from '@shared/address/autocomplete'
import type { AccessAddressSuggestion, FullAddressSuggestion } from '@shared/address/autocomplete'

// The portal reaches the backend through its own axios instance rather than the app SDK, so it builds its
// own client over the shared address autocomplete (`@shared/address/autocomplete`), which replaces DAWA's
// retired `/autocomplete`. Suggestion types live in the shared module — import them from there directly.
//
// Note: the portal's virk Address has no `cityName`, so that field of the shared field set is ignored here.

const addressAutocomplete = createAddressAutocomplete(async path => (await axios.get('/' + path)).data)

export const loadSuggestions = addressAutocomplete.loadSuggestions

export async function createAddressFromSuggestion (suggestion: AccessAddressSuggestion | FullAddressSuggestion): Promise<Address> {
  return new Address(await addressAutocomplete.createAddressFields(suggestion))
}
